import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseRequest from '@/use/usePurchaseRequest';

import { material_code } from '../Job/SubJob/base';

const { classMap, translate } = usePurchaseRequest();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    production_type: {
      name: 'ประเภท',
      width: '4rem',
    },
    job_no: {
      name: 'Sub Job No.',
      width: '8rem',
    },
    drawing_no: {
      name: 'Drawing No. / Part No.',
      width: '10rem',
    },
    description: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    material_code: {
      ...material_code,
      width: '1.5fr',
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      class: {
        cell: 'text-center',
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return classMap(val, true);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val, row.item.approved);
      },
    },
    neededAmount: {
      name: 'จำนวนที่ต้องการ',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    amount: {
      name: 'จำนวน',
      width: '8rem',
      class: 'text-center',
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-center',
    },
    remarks: {
      name: 'หมายเหตุ',
      width: '6rem',
      class: 'text-center',
    },
  },
};
